/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentQueryPillar extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentQueryPillar");
    }

    getFixupPrototypeFunction() { return AssessmentQueryPillar.fixupPrototype; }

    static newInstance(model: Partial<AssessmentQueryPillar>): AssessmentQueryPillar {
        let obj = Object.assign(new AssessmentQueryPillar(), model);
        AssessmentQueryPillar.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentQueryPillar>): AssessmentQueryPillar {
        if (!model) return null;
        return AssessmentQueryPillar.newInstance(<AssessmentQueryPillar> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentQueryPillar) {
        if (!obj) return;

        models.AssessmentQueryPillar.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentQueryPillar): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentQueryPillar.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * ID of pillar
     */
    pillar_ids: Array<string>;

}
